import { Globe, Sparkles, Heart } from "lucide-react";
import NotificationBell from "@/components/NotificationBell";
import { LanguageSwitcher } from "@/components/LanguageSwitcher";
import { cn } from "@/lib/utils";

interface MatchesHeaderProps {
  stats: {
    total: number;
    exhibition: number;
    popBalloon: number;
    globalConnect: number;
  };
}

export const MatchesHeader = ({ stats }: MatchesHeaderProps) => {
  return (
    <header className="sticky top-0 bg-card/95 backdrop-blur-xl border-b border-border/50 z-30 shadow-sm">
      <div className="px-4 py-4 safe-area-top">
        {/* Title row */}
        <div className="flex items-center justify-between mb-3 animate-fade-in">
          <div className="w-10" />
          <h1 className="text-xl font-bold text-center">My Matches</h1>
          <div className="flex items-center gap-2">
            <LanguageSwitcher position="top-right" className="relative" />
            <NotificationBell />
          </div>
        </div>

        {/* Stats row */}
        <div className="flex items-center justify-center gap-4 animate-fade-in-up" style={{ animationDelay: "0.1s" }}>
          {/* Total */}
          <div className="flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-primary/10">
            <Heart className="w-4 h-4 text-primary" />
            <span className="text-sm font-semibold text-primary">{stats.total}</span>
          </div>

          {/* Per-source mini stats */}
          <div className="flex items-center gap-2">
            <div className={cn(
              "flex items-center gap-1 px-2 py-1 rounded-full text-xs",
              stats.popBalloon > 0 ? "bg-pink-500/15 text-pink-600" : "bg-muted/50 text-muted-foreground"
            )}>
              <span>🎈</span>
              <span className="font-medium">{stats.popBalloon}</span>
            </div>

            <div className={cn(
              "flex items-center gap-1 px-2 py-1 rounded-full text-xs",
              stats.globalConnect > 0 ? "bg-blue-500/15 text-blue-600" : "bg-muted/50 text-muted-foreground"
            )}>
              <Globe className="w-3 h-3" />
              <span className="font-medium">{stats.globalConnect}</span>
            </div>

            <div className={cn(
              "flex items-center gap-1 px-2 py-1 rounded-full text-xs",
              stats.exhibition > 0 ? "bg-amber-500/15 text-amber-600" : "bg-muted/50 text-muted-foreground"
            )}>
              <Sparkles className="w-3 h-3" />
              <span className="font-medium">{stats.exhibition}</span>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};
